<script setup>

import {ref, useAttrs} from "vue";
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";
import EditToggleButton from "../../Pub/components/EditToggleButton.vue";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const isEditing = ref(false)
const hoverActive = ref(false)

const toggleEdit = () => {
    isEditing.value = !isEditing.value
    if (!isEditing.value) {
        hoverActive.value = false
    }
}

const attrs = useAttrs();

const props = defineProps({
    resource: {
        type: Object,
        required: true,
    },
    resourceField: {
        type: String,
        required: true,
    }
});

</script>

<template>
    <div
        class="relative"
        @mouseenter="hoverActive = true"
        @mouseleave="hoverActive = false"
    >
        <edit-toggle-button
            v-show="portalContentAndDesignStore.liveDesignerEnabled && (isEditing || hoverActive)"
            :isEditing="isEditing"
            @toggle="toggleEdit"
            class="transition-opacity duration-200"
        />

        <div
            v-if="resource[resourceField] && !isEditing"
            v-bind="attrs"
            v-html="resource[resourceField]"
        />
        
        <text-editor
            v-else-if="portalContentAndDesignStore.liveDesignerEnabled && isEditing"
            :text="resource[resourceField]"
            @input="(newValue) => { resource[resourceField] = newValue }"
        />
    </div>
</template>

